export const DEFAULT_LEFT_PANEL_PERCENT = 30;
export const MIN_LEFT_PANEL_PERCENT = 20;
export const MAX_LEFT_PANEL_PERCENT_TWO_COLUMNS = 80;
export const MAX_LEFT_PANEL_PERCENT_THREE_COLUMNS = 60;

export interface SplitBounds {
  left: number;
  width: number;
}

export function clampSplitPercent(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function getSplitPercentFromPointer(
  clientX: number,
  bounds: SplitBounds,
  min: number,
  max: number,
): number {
  if (bounds.width <= 0) return min;
  const rawPercent = ((clientX - bounds.left) / bounds.width) * 100;
  return clampSplitPercent(Math.round(rawPercent), min, max);
}
